import { Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import ProtectedRoute from "./ProtectedRoutes";
import GenericError from "@components/errors/GenericError";
import RefundManagement from "src/modules/refunds/RefundManagement";
import { useMediaQuery } from "react-responsive";
import LoginPage from "src/modules/authentication/LoginPage";
import VerifyOtp from "src/modules/authentication/VerifyOtpPage";
import MobileLayout from "./LayoutMobile";
import RefundManagementMobile from "src/modules/refunds/mobile/RefundManagementMobile";
import RefundDetails from "src/modules/refunds/RefundDetails";

const AppRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 640 });

  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/verifyOtp" element={<VerifyOtp />} />
      <Route path="/error" element={<GenericError />} />
      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        {isMobile ? (
          <>
            <Route element={<MobileLayout />}>
              <Route path="/" element={<RefundManagementMobile />} />
            </Route>
            <Route
              path="/refund-detail"
              element={<RefundDetails refundId="0" width="w-full" />}
            />
          </>
        ) : (
          <>
            <Route element={<Layout initialSelectedTab={"prime_order_flow"} />}>
              <Route path="/" element={<RefundManagement />} />
            </Route>
          </>
        )}
      </Route>
    </Routes>
  );
};

export default AppRouter;
